import { cached } from '@glimmer/tracking';
import currency from 'currency.js';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import FundCustomRecordModel from 'donor-elf-web/models/fund-custom-record';

export default class OmsMonthlySummary {
  constructor(fundCustomRecord: FundCustomRecordModel) {
    this.startDate = fundCustomRecord.data.start_date;
    this.openingBalance = fundCustomRecord.data.opening_balance || 0;
    this.closingBalance = fundCustomRecord.data.closing_balance || 0;
    this.status = fundCustomRecord.data.status;
    this.revenueAccountSummaries = sortByProperties(
      fundCustomRecord.data.account_summaries.filter(
        (x: any) => x.type === 'Revenue',
      ),
      ['name'],
    );
    this.expenseAccountSummaries = sortByProperties(
      fundCustomRecord.data.account_summaries.filter(
        (x: any) => x.type === 'Expense',
      ),
      ['name'],
    );
  }

  startDate!: string;
  openingBalance!: number;
  closingBalance!: number;
  status!: 'Open' | 'Closed';
  revenueAccountSummaries!: AccountSummary[];
  expenseAccountSummaries!: AccountSummary[];

  @cached
  get totalRevenue() {
    return this.revenueAccountSummaries.reduce(
      (sum: number, item: AccountSummary) => {
        return currency(sum).add(item.amount).value;
      },
      0,
    );
  }

  @cached
  get totalExpense() {
    return this.expenseAccountSummaries.reduce(
      (sum: number, item: AccountSummary) => {
        return currency(sum).add(item.amount).value;
      },
      0,
    );
  }

  get netIncome() {
    return this.totalRevenue + this.totalExpense;
  }
}

interface AccountSummary {
  name: string;
  amount: number;
}
